import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  ChatDocumentReference,
  DocumentReferenceEntityType,
  entityName,
} from '@qtek/shared/models';
import { DocumentReferenceService } from '../core/document-reference.service';

@Injectable({ providedIn: 'root' })
export class ChatDocumentReferenceService extends DocumentReferenceService<ChatDocumentReference> {
  protected http = inject(HttpClient);
  protected entityName: entityName = 'ChatDocumentReference';
  readonly entityType = DocumentReferenceEntityType.CHAT;
}
